import Box from "@mui/material/Box";
import { MessageBar, MessageBarType } from "@fluentui/react/lib/MessageBar";
import * as React from "react";
import { styles } from "./FTL.styles";

export function FtlErrorMessageBar({
  message,
  onDismiss,
  errorRef,
}: {
  message: string | null;
  onDismiss: () => void;
  errorRef: React.RefObject<HTMLDivElement | null>;
}): React.ReactElement | null {
  if (!message) return null;
  return (
    <Box ref={errorRef} sx={styles.errorWrapper}>
      <MessageBar messageBarType={MessageBarType.error} isMultiline={false} onDismiss={onDismiss}>
        {message}
      </MessageBar>
    </Box>
  );
}
